// i18n
import { i18n } from '@ecg-internal/js-react-i18n';
import { nl as dateLocale } from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-BE/translation.json';
import common from '../../../../locales/nl-BE/common.json';

export default i18n.init({
  lng: 'nl-BE',
  translations: {
    translation,
    common,
  },
  dateLocale,
});
